import React from 'react'

type TextSize = 'xs' | 'sm' | 'base' | 'lg';
type FontWeight = 'normal' | 'medium' | 'semibold' | 'bold';

const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
} as const;

const weightClasses = {
    normal: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
    bold: 'font-bold',
} as const;

// Base text component
interface TextProps {
    children: React.ReactNode;
    className?: string;
    size?: TextSize;
    weight?: FontWeight;
}

export const Text = ({ children, className = "", size = 'base', weight = 'normal' }: TextProps) => (
    <p className={`text-black dark:text-white ${sizeClasses[size]} ${weightClasses[weight]} ${className}`}>
        {children}
    </p>
);

// Form label component
interface LabelProps extends TextProps {
    htmlFor?: string;
    required?: boolean;
}

export const Label = ({ children, className = "", htmlFor, required = false, size = 'sm', weight = 'medium' }: LabelProps) => (
    <label
        className={`mb-3 block text-black dark:text-white ${sizeClasses[size]} ${weightClasses[weight]} ${className}`}
        htmlFor={htmlFor}
    >
        {children}
        {required && <span className="text-red-500 ml-1">*</span>}
    </label>
);


// Muted text component 
export const MutedText = ({ children, className = "", size = 'sm' }: TextProps) => (
    <span className={`text-gray-500 dark:text-gray-400 ${sizeClasses[size]} ${className}`}>
        {children}
    </span>
);

